export default __webpack_public_path__ + "static/screeny-130-gpz-tens-to-4-336124338e4d37b607fbdb2f621b6fb8.jpg";